import { Marked } from 'marked';

/**
 * Our own Marked instance, never the shared `marked` singleton.
 *
 * `marked.use()` is global: configuring the singleton here would change how the Antares rulebook
 * renders its own markdown, which is authored by staff under different rules and wants its raw
 * HTML kept. An instance keeps the two from reaching each other.
 *
 * `breaks` is not a preference. The fields this serves were plain textareas whose line breaks were
 * preserved verbatim, so every description, parking note and scoring rule already saved was written
 * expecting a newline to be a newline. Markdown's default folds single newlines into spaces, which
 * would reflow all of that text the day this shipped.
 */
const renderer = new Marked({ breaks: true, gfm: true, async: false });

/**
 * Raw HTML is dropped rather than passed through.
 *
 * Organiser-authored text is read by every registered player, so it must not carry markup. The
 * rulebook renders its markdown through `bypassSecurityTrustHtml` - defensible for content staff
 * wrote, and not defensible here. Markdown itself permits inline HTML, so without this a `<script>`
 * typed into a parking note would reach the page.
 *
 * This is the first of two guards: MarkdownComponent additionally lets Angular's sanitizer run.
 */
renderer.use({ renderer: { html: () => '' } });

/** Renders the markdown an event organiser typed into HTML. */
export function renderMarkdown(source: string | undefined | null): string {
    if (!source || !source.trim()) {
        return '';
    }

    return renderer.parse(source) as string;
}
